import resetState from './default';

const setHasSmartMeter = (state, value) => state.smartMeter.hasSmartMeter = value;
const setHasQuarterRegime = (state, value) => state.smartMeter.hasQuarterRegime = value;
const setKnowPeakLevel = (state, value) => state.smartMeter.knowPeakLevel = value;
const setPeakLevel = (state, value) => state.smartMeter.peakLevel = value;
const setKnowConsumption = (state, value) => state.knowConsumption = value;
const setKnowNetConsumption = (state, value) => state.knowNetConsumption = value;
const setConsumptions = (state, value) => state.consumptions = value;
const setConsumptionsElectricity = (state, value) => state.consumptions.electricity = value;
const setConsumptionsMono = (state, value) => state.consumptions.electricity.mono = value;
const setConsumptionsDay = (state, value) => state.consumptions.electricity.day = +value > 0 ? value : "0";
const setConsumptionsNight = (state, value) => state.consumptions.electricity.night = +value > 0 ? value : "0";
const setConsumptionsExclusiveNight = (state, value) => state.consumptions.electricity.exclusiveNight = value;
const setConsumptionsGas = (state, value) => state.consumptions.gas = value;
const setConsumptionsInjectionBase = (state, value) => state.consumptions.electricity.injectionBase = value;
const setConsumptionsInjectionDay = (state, value) => state.consumptions.electricity.injectionDay = value;
const setConsumptionsInjectionNight = (state, value) => state.consumptions.electricity.injectionNight = value;
const setInhabitants = (state, value) => state.inhabitants = value;
const setHouseSize = (state, value) => state.houseSize = value;
const setOccupation = (state, value) => state.occupation = value;
const setHeating = (state, value) => state.heating = value;
const setWater = (state, value) => state.water = value;
const setDishwasher = (state, value) => state.dishwasher = value;
const setDryer = (state, value) => state.dryer = value;
const setWashingMachine = (state, value) => state.washingMachine = value;
const setElectricCar = (state, value) => state.electricCar = value;
const setBattery = (state, value) => state.battery = value;
const reset = (state) => Object.assign(state, resetState.getDefaultState());

export default {
  setHasSmartMeter,
  setHasQuarterRegime,
  setKnowPeakLevel,
  setPeakLevel,
  setKnowConsumption,
  setKnowNetConsumption,
  setConsumptions,
  setConsumptionsMono,
  setConsumptionsDay,
  setConsumptionsNight,
  setConsumptionsExclusiveNight,
  setConsumptionsGas,
  setConsumptionsElectricity,
  setConsumptionsInjectionBase,
  setConsumptionsInjectionDay,
  setConsumptionsInjectionNight,
  setInhabitants,
  setHouseSize,
  setOccupation,
  setHeating,
  setWater,
  setDishwasher,
  setDryer,
  setWashingMachine,
  setElectricCar,
  setBattery,
  reset
}



// WEBPACK FOOTER //
// ./src/store/modules/consumption/mutations.js